import { logger } from '@shared/lib/utils/logger'
const ACCESS_TOKEN_KEY = 'professionals_access_token'

/**
 * Centralized JWT token management in localStorage
 * Stores authentication tokens received from login endpoint
 */
export const tokenStorage = {
  /**
   * Save JWT token to localStorage
   */
  setToken(token: string): void {
    try {
      localStorage.setItem(ACCESS_TOKEN_KEY, token)
    } catch (error) {
      logger.error('[tokenStorage] Failed to save token to localStorage:', error)
    }
  },

  /**
   * Get JWT token from localStorage
   */
  getToken(): string | null {
    try {
      return localStorage.getItem(ACCESS_TOKEN_KEY)
    } catch (error) {
      logger.error('[tokenStorage] Failed to load token from localStorage:', error)
      return null
    }
  },

  /**
   * Remove token from localStorage
   */
  clearToken(): void {
    try {
      localStorage.removeItem(ACCESS_TOKEN_KEY)
    } catch (error) {
      logger.error('[tokenStorage] Failed to clear token from localStorage:', error)
    }
  },

  /**
   * Check if token exists in localStorage
   */
  hasToken(): boolean {
    return !!this.getToken()
  },
}
